/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

document.addEventListener("DOMContentLoaded", function () {
  let intervalCount = 0;
  const maxIntervalCount = 50;

  const interval = setInterval(() => {
      const sliderElement = document.querySelector('.lookbook__slider');
      if (sliderElement) {
          clearInterval(interval);
          var flkty = new Flickity(sliderElement);
          const touchpoints = document.querySelectorAll('[data-touchpoint]');

          touchpoints.forEach((touchpoint) => {
              touchpoint.addEventListener('click', () => {
                  const touchpointIndex = touchpoint.getAttribute('data-touchpoint');
                  flkty.select(touchpointIndex);
                  touchpoints.forEach(tp => tp.classList.remove('active-touchpoint'));
                  touchpoint.classList.add('active-touchpoint');
              });
          });
      } else if (intervalCount >= maxIntervalCount) {
          clearInterval(interval);
      }

      intervalCount++;
  }, 300);

  function setReplayVideoButton() {
      const video = document.querySelector(".custom-video");
      const replayButton = document.querySelector("[data-replay-video]");
      const customVideoBanner = document.querySelector('.custom-video-banner');

      if (!video || !replayButton) return;

      video.addEventListener("ended", () => {
          replayButton.classList.remove("hide");
          customVideoBanner.classList.remove("hide");
      });

      replayButton.addEventListener("click", () => {
          video.currentTime = 0;
          video.play();
          replayButton.classList.add("hide");
          customVideoBanner.classList.add("hide");
      });
  }

  if (document.querySelector(".custom-video")) {
      setReplayVideoButton();
  }

  moveMobilePDPElements();

});

function moveMobilePDPElements() {
  let target = document.querySelector('.template-product .product-form .jdgm-widget');
  let target2 = document.querySelector('.template-product .product-form > h4.product-form__text');
  let container = document.querySelector('.template-product .product-meta.hide-desktop');
  if(!target || !container) return;

  let clone = target.cloneNode(true);
  clone.classList.add('hide-desktop');
  target.classList.add('hide-mobile');

  container.parentNode.insertBefore(clone, container.nextSibling);
  if(target2) {
        let clone2 = target2.cloneNode(true);
        clone2.classList.add('hide-desktop');
        target2.classList.add('hide-mobile');
        container.appendChild(clone2);
    }
}

// Request native fullscreen for the video popup when supported. Only applies
// to native <video> popups: YouTube/Vimeo iframes already ship their own
// fullscreen button (allowfullscreen + default player controls), and there is
// no postMessage command to trigger it from the parent page - the Fullscreen
// API requires a real user gesture inside the iframe's own document, which
// can't be relayed cross-origin. Falls back to iOS Safari's video-only
// fullscreen API. Silently does nothing if neither is available (the popup
// still fills the section via CSS).
function requestVideoPopupFullscreen(video) {
  if (!video || video.tagName !== 'NATIVE-VIDEO') {
    return;
  }
  const videoEl = video.querySelector('video');
  if (!videoEl) {
    return;
  }
  const requestFs = videoEl.requestFullscreen || videoEl.webkitRequestFullscreen || videoEl.mozRequestFullScreen || videoEl.msRequestFullscreen;
  if (requestFs) {
    requestFs.call(videoEl).catch(() => {});
  } else if (typeof videoEl.webkitEnterFullscreen === 'function') {
    videoEl.webkitEnterFullscreen();
  }
}

function exitVideoPopupFullscreen() {
  const fullscreenElement = document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
  if (fullscreenElement && fullscreenElement.closest('.video-popup-modal')) {
    const exitFs = document.exitFullscreen || document.webkitExitFullscreen || document.mozCancelFullScreen || document.msExitFullscreen;
    if (exitFs) {
      exitFs.call(document).catch(() => {});
    }
  }
}

['fullscreenchange', 'webkitfullscreenchange', 'mozfullscreenchange', 'MSFullscreenChange'].forEach((eventName) => {
  document.addEventListener(eventName, () => {
    const fullscreenElement = document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
    if (!fullscreenElement) {
      // The user exited fullscreen (Escape key, browser control, etc.) - close any open video popup to match.
      document.querySelectorAll('.video-popup-modal[open]').forEach((modal) => {
        modal.open = false;
      });
    }
  });
});

// Video modal functionality for collection-list, image-with-text, and video popup sections
document.addEventListener('openable-element:open', function(event) {
  const modal = event.target;
  if (modal.classList.contains('modal-content-collection-list') || modal.classList.contains('video-popup-modal')) {
    const video = modal.querySelector('external-video, native-video');
    if (video) {
      // Pause any other playing videos first
      const allVideos = document.querySelectorAll('external-video, native-video');
      allVideos.forEach(otherVideo => {
        if (otherVideo !== video && typeof otherVideo.pause === 'function') {
          otherVideo.pause();
        }
      });

      if (video.tagName === 'NATIVE-VIDEO') {
        video.play();
        if (modal.classList.contains('video-popup-modal')) {
          requestVideoPopupFullscreen(video);
        }
        return;
      }

      if (typeof video.play === 'function') {
        video.play().catch((error) => {
          console.error('Error playing video:', error);
        });
      }

      // The external-video element has `autoplay` (see the markup), so the
      // theme's own ExternalVideo class already preloads it - muted, silently
      // - once the section scrolls near the viewport, well before the user
      // taps the button. That's what fixes the "doesn't autoplay the first
      // time on mobile" bug: by the time this fires, the player is normally
      // already warmed up instead of doing a cold network/script load. Since
      // it may have been sitting there muted-playing for a while, seek back
      // to the start so it always plays from 0:00 when actually opened, then
      // play/unmute. Kept on a retry interval as a fallback for the rare case
      // where the section scrolled into view and opened in the same instant,
      // before the preload finished - every call here is idempotent.
      if (video._unmuteInterval) {
        clearInterval(video._unmuteInterval);
      }
      let unmuteAttempts = 0;
      const maxUnmuteAttempts = 10;
      video._unmuteInterval = setInterval(() => {
        unmuteAttempts++;
        const iframe = video.querySelector('iframe');
        if (iframe && iframe.contentWindow) {
          const provider = video.getAttribute('provider');
          if (provider === 'youtube') {
            if (unmuteAttempts === 1) {
              iframe.contentWindow.postMessage(JSON.stringify({ event: "command", func: "seekTo", args: [0, true] }), "*");
            }
            iframe.contentWindow.postMessage(JSON.stringify({ event: "command", func: "playVideo", args: "" }), "*");
            iframe.contentWindow.postMessage(JSON.stringify({ event: "command", func: "unMute", args: "" }), "*");
          } else if (provider === 'vimeo') {
            if (unmuteAttempts === 1) {
              iframe.contentWindow.postMessage(JSON.stringify({ method: "setCurrentTime", value: 0 }), "*");
            }
            iframe.contentWindow.postMessage(JSON.stringify({ method: "play" }), "*");
            iframe.contentWindow.postMessage(JSON.stringify({ method: "setVolume", value: 1 }), "*");
          }
        }
        if (unmuteAttempts >= maxUnmuteAttempts) {
          clearInterval(video._unmuteInterval);
        }
      }, 400);
    }
  }
});

class NavDropdownToggle extends HTMLButtonElement {
  connectedCallback() {
    this.addEventListener('click', this._handleClick.bind(this));
    document.addEventListener('keydown', this._handleEscape = this._handleEscape.bind(this));
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this._handleEscape);
  }

  _handleClick() {
    const li = this.closest('.has-dropdown');
    const nav = this.closest('desktop-navigation');
    if (!li || !nav) return;
    this.getAttribute('aria-expanded') === 'true'
      ? nav.closeDropdown(li)
      : nav.openDropdown(li);
  }

  _handleEscape(event) {
    if (event.key !== 'Escape' || this.getAttribute('aria-expanded') !== 'true') return;
    const li = this.closest('.has-dropdown');
    const nav = this.closest('desktop-navigation');
    if (!li || !nav) return;
    nav.closeDropdown(li);
    this.focus();
  }
}

customElements.define('nav-dropdown-toggle', NavDropdownToggle, { extends: 'button' });

class PauseVideoButton extends HTMLElement {
  connectedCallback() {
    this._playing = true; // autoplay sections start playing

    this.addEventListener("click", this._toggle.bind(this));
    this.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        this._toggle();
      }
    });

    const target = this._target();
    if (!target) return;

    target.addEventListener("video:played", () => this._sync(true));
    target.addEventListener("video:paused", () => this._sync(false));
  }

  _target() {
    const id = this.getAttribute("aria-controls");
    return id ? document.getElementById(id) : null;
  }

  _sync(isPlaying) {
    this._playing = isPlaying;
    this.setAttribute("aria-pressed", isPlaying ? "false" : "true");
  }

  _toggle() {
    const target = this._target();
    if (!target) return;
    this._playing ? target.pause() : target.play();
  }
}

customElements.define("pause-video-button", PauseVideoButton);

/* ============================================
   COUNTDOWN TIMER
   ============================================ */
class CountdownTimer extends HTMLElement {
  connectedCallback() {
    const tz = this.getAttribute('timezone') || 'America/Boise';
    this._endTime = this._parseInTimezone(this.getAttribute('end-time'), tz);
    this._title = this.getAttribute('title') || '';
    this._endMessage = this.getAttribute('end-message') || '';
    this._showDays = null;
    this._render();
    this._interval = setInterval(() => this._tick(), 1000);
  }

  // Interprets a "YYYY-MM-DDTHH:MM:SS" string as wall-clock time in the given
  // IANA timezone and returns the equivalent UTC Date. Two-pass correction
  // handles DST boundary edge cases.
  _parseInTimezone(dateStr, tz) {
    const d = new Date(dateStr + 'Z'); // treat as UTC to get a numeric anchor
    const offset = this._tzOffsetMs(d, tz);
    const adjusted = new Date(d.getTime() + offset);
    const offset2 = this._tzOffsetMs(adjusted, tz);
    return offset === offset2 ? adjusted : new Date(d.getTime() + offset2);
  }

  // Returns (UTC ms - local ms in tz): positive when tz is behind UTC.
  _tzOffsetMs(date, tz) {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: tz,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hour12: false,
    }).formatToParts(date);
    const p = Object.fromEntries(parts.filter(x => x.type !== 'literal').map(x => [x.type, x.value]));
    const localMs = Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour % 24, +p.minute, +p.second);
    return date.getTime() - localMs;
  }

  disconnectedCallback() {
    clearInterval(this._interval);
  }

  _getTimeLeft() {
    const diff = this._endTime - Date.now();
    if (diff <= 0) return { expired: true };

    const totalSeconds = Math.floor(diff / 1000);
    const showDays = totalSeconds >= 72 * 3600;
    return {
      days:    Math.floor(totalSeconds / 86400),
      hours:   showDays
                 ? Math.floor((totalSeconds % 86400) / 3600)
                 : Math.floor(totalSeconds / 3600),
      minutes: Math.floor((totalSeconds % 3600) / 60),
      seconds: totalSeconds % 60,
      showDays,
      expired: false,
    };
  }

  _pad(n) {
    return String(n).padStart(2, '0');
  }

  _render() {
    const state = this._getTimeLeft();

    if (state.expired) {
      this.innerHTML = this._endMessage
        ? `<h3 class="heading h5">${this._endMessage}</h3>`
        : "";
      clearInterval(this._interval);
      return;
    }

    this._showDays = state.showDays;

    const units = [];
    if (state.showDays) units.push({ value: state.days,    label: 'Days'    });
    units.push(
      { value: state.hours,   label: 'Hours'   },
      { value: state.minutes, label: 'Min' },
      { value: state.seconds, label: 'Sec' }
    );

    const sep = `<span class="countdown-timer__separator heading heading--large text--primary" aria-hidden="true">:</span>`;
    const titleHTML = this._title ? `<h3 class="heading">${this._title}</h3>` : '';

    this.innerHTML = `${titleHTML}<div class="countdown-timer">${
      units.map(u => `
        <div class="countdown-timer__unit">
          <span class="countdown-timer__value heading heading--large" data-countdown-value>${this._pad(u.value)}</span>
          <span class="countdown-timer__label heading h6">${u.label}</span>
        </div>
      `).join(sep)
    }</div>`;
  }

  _tick() {
    const state = this._getTimeLeft();

    if (state.expired) {
      this.innerHTML = this._endMessage
        ? `<p class="heading heading--small">${this._endMessage}</p>`
        : '';
      clearInterval(this._interval);
      return;
    }

    if (state.showDays !== this._showDays || !this.querySelector('[data-countdown-value]')) {
      this._render();
      return;
    }

    const values = state.showDays
      ? [state.days, state.hours, state.minutes, state.seconds]
      : [state.hours, state.minutes, state.seconds];

    this.querySelectorAll('[data-countdown-value]').forEach((el, i) => {
      el.textContent = this._pad(values[i]);
    });
  }
}

customElements.define('countdown-timer', CountdownTimer);

class AdditionalProduct extends HTMLElement {
  connectedCallback() {
    const form = document.getElementById(this.getAttribute('form-id'));
    if (!form) return;

    // Seed variant price from JSON if present, otherwise fall back to the liquid-rendered attribute
    const variantScript = document.querySelector(`#shopify-section-${this.getAttribute('section-id')} script[data-variant]`);
    let jsonPrice = 0;
    try { jsonPrice = JSON.parse(variantScript?.textContent)?.price || 0; } catch(e) {}
    this._variantPrice = jsonPrice || parseInt(this.getAttribute('initial-variant-price')) || 0;

    document.addEventListener('variant:changed', (e) => {
      if (e.target !== form) return;
      this._variantPrice = e.detail.variant?.price || 0;
      requestAnimationFrame(() => this._updateButton(form));
    });

    this.addEventListener('change', (e) => {
      if (e.target.matches('[data-add-on-variant-select]')) {
        const select = e.target;
        const selectedOption = select.options[select.selectedIndex];
        const item = select.closest('.product-form__add-on__item');
        const checkbox = item?.querySelector('.product-form__add-on__checkbox');
        if (checkbox && selectedOption) {
          checkbox.value = selectedOption.value;
          checkbox.dataset.price = selectedOption.dataset.price;
        }
        const img = item?.querySelector('.product-form__add-on__image-link img');
        if (img && selectedOption?.dataset.image) {
          img.src = selectedOption.dataset.image;
        }
      }
      this._updateButton(form);
    });
    if (typeof formatMoney === 'function') {
      this._updateButton(form);
    } else {
      document.addEventListener('DOMContentLoaded', () => this._updateButton(form), { once: true });
    }
  }

  _updateButton(form) {
    const btn = form.querySelector('#AddToCart .loader-button__text') || form.querySelector('#AddToCart');
    if (!btn) return;

    const baseText = btn.textContent.split(' | ')[0].trim();
    const checked = this.querySelectorAll('.product-form__add-on__checkbox:checked');

    const addOnTotal = Array.from(checked).reduce((sum, cb) => sum + (parseInt(cb.dataset.price) || 0), 0);
    btn.textContent = `${baseText} | ${formatMoney(this._variantPrice + addOnTotal)}`;

    const stickyButton =
      document.querySelector("#StickyAddToCart .loader-button__text") ||
      document.querySelector("#StickyAddToCart");
    if(stickyButton){
      stickyButton.textContent = `${baseText} | ${formatMoney(this._variantPrice + addOnTotal)}`;
    }
  }
};

customElements.define('additional-product', AdditionalProduct);


document.addEventListener('openable-element:close', function(event) {
    const modal = event.target;
    if (modal.classList.contains('modal-content-collection-list') || modal.classList.contains('video-popup-modal')) {
        if (modal.classList.contains('video-popup-modal')) {
            exitVideoPopupFullscreen();
        }
        const video = modal.querySelector('external-video, native-video');
        if (video) {
            if (video._unmuteInterval) {
                clearInterval(video._unmuteInterval);
                video._unmuteInterval = null;
            }
            if (typeof video.pause === 'function') {
                video.pause();
            }
            // Belt-and-suspenders: send the postMessage pause command directly
            // too, in case the custom element's internal state thinks it
            // hasn't "loaded" yet and skips its own pause() logic.
            const iframe = video.querySelector && video.querySelector('iframe');
            if (iframe && iframe.contentWindow) {
                const provider = video.getAttribute('provider');
                if (provider === 'youtube') {
                    iframe.contentWindow.postMessage(JSON.stringify({ event: "command", func: "pauseVideo", args: "" }), "*");
                } else if (provider === 'vimeo') {
                    iframe.contentWindow.postMessage(JSON.stringify({ method: "pause" }), "*");
                }
            }
        }
    }
});

/* ============================================
   PRODUCT FORM — VARIANT CASCADE
   ============================================ */
(function () {

  function cascadeOptionAvailability(formId) {
    if (!formId && document.querySelector('.product-form.unselected-variant')) return;

    document.querySelectorAll('.product-form.unselected-variant, .product-sticky-form.unselected-variant').forEach(el => {
      el.classList.remove('unselected-variant');
    });

    const selector = formId
      ? `script[data-product-variant-options][data-form-id="${formId}"]`
      : `script[data-product-variant-options]`;

    document.querySelectorAll(selector).forEach(dataEl => {
      const dataElFormId = dataEl.dataset.formId;
      const { optionIndex, variants } = JSON.parse(dataEl.textContent);
      const optionCount = variants[0]?.length ?? 0;
      const nonColorIndices = Array.from({ length: optionCount }, (_, i) => i).filter(i => i !== optionIndex);

      const colorInput = document.querySelector(`product-rerender input[data-option-position="${optionIndex + 1}"][form="${dataElFormId}"]:checked`);
      if (!colorInput) return;

      const currentSelections = { [optionIndex]: colorInput.dataset.value };
      let hasInvalidSelection = false;

      for (const idx of nonColorIndices) {
        const position = idx + 1;

        const validValues = new Set(
          variants
            .filter(opts => Object.entries(currentSelections).every(([i, v]) => opts[Number(i)] === v))
            .map(opts => opts[idx])
        );

        document.querySelectorAll(`.block-swatch input[data-option-position="${position}"][form="${dataElFormId}"]`).forEach(input => {
          input.closest('.block-swatch').classList.toggle('hidden', !validValues.has(input.getAttribute('data-value')));
        });

        const checkedInput = document.querySelector(`product-rerender input[data-option-position="${position}"][form="${dataElFormId}"]:checked`);
        if (checkedInput) {
          if (!validValues.has(checkedInput.dataset.value)) hasInvalidSelection = true;
          currentSelections[idx] = checkedInput.dataset.value;
        }
      }

      document.getElementById('AddToCart')?.closest('form')?.classList.toggle('has-invalid-selection', hasInvalidSelection);
    });
  }

  function onSwatchClick(e) {
    if (
      e.target.closest('.product-form.unselected-variant') &&
      (e.target.classList.contains('block-swatch__item') ||
        e.target.classList.contains('color-swatch__item') ||
        e.target.closest('.color-swatch__item') ||
        e.target.closest('.block-swatch__item'))
    ) {
      const input = e.target.closest('div').querySelector('input[data-option-position]');
      if (input?.checked) input.dispatchEvent(new CustomEvent('change', { bubbles: true }));
    }

    if (
      e.target.closest('.product-sticky-form.unselected-variant') &&
      e.target.classList.contains('combo-box__option-item')
    ) {
      const select = e.target.closest('combo-box').querySelector('select');
      const selectOption = select.querySelector(`option[value="${e.target.value}"]`);
      if (selectOption?.selected) select.dispatchEvent(new CustomEvent('change', { bubbles: true }));
    }
  }

  function onSelectOptionsPress(e) {
    const button = e.target.closest('button[disabled][select-options]');
    if (!button) return;

    const invalidOption = document.querySelector(
      '.product-form__option-selector:has(.block-swatch.hidden input:checked), .product-form__option-selector:has(.color-swatch.hidden input:checked)'
    );
    const firstOption = document.querySelector('.product-form__option-selector');
    const target = invalidOption ?? firstOption ?? button;

    const anchor = target.querySelector('.product-form__option-name') ?? target;

    const existingError = anchor.nextElementSibling?.classList.contains('product-form__error')
      ? anchor.nextElementSibling
      : null;
    if (existingError) {
      existingError.classList.remove('product-form__error--pulse');
      void existingError.offsetWidth;
      existingError.classList.add('product-form__error--pulse');
      return;
    }
    document.querySelectorAll('.product-form__error').forEach(el => el.remove());

    const banner = document.createElement('div');
    banner.className = "product-form__error product-form__error--pulse";
    const optionName = (invalidOption ?? firstOption)?.dataset.option;
    banner.textContent = optionName
      ? `Please select a ${optionName.charAt(0).toUpperCase()}${optionName.slice(1)}`
      : 'Please select options';
    anchor.insertAdjacentElement("afterend", banner);
  }

  document.addEventListener('product:rerendered', e => cascadeOptionAvailability(e.detail.formId));
  document.addEventListener('DOMContentLoaded', () => cascadeOptionAvailability());
  document.addEventListener('click', onSwatchClick);
  document.addEventListener('pointerdown', onSelectOptionsPress);

})();

/* ============================================
   INFINITE SCROLL / LAZY LOADING CONTROLLER
   ============================================ */
(function() {
  'use strict';

  const AUTO_LOAD_CAP = 5;
  const MAX_PAGES_TOTAL = 10; // ~240 products at 24/page
  const SESSION_KEY_PREFIX = 'infinite-scroll:';

  class InfiniteScrollController {
    constructor() {
      this.productFacet = null;
      this.productList = null;
      this.productListInner = null;
      this.loadMoreContainer = null;
      this.loadMoreButton = null;
      this.srStatus = null;
      this.intersectionObserver = null;
      this.mutationObserver = null;
      this.abortController = null;
      this.isLoading = false;
      this.currentPage = 1;
      this.totalPages = 1;
      this.autoLoadCount = 0;
      this.totalLoadedPages = 1; // includes initial page
      this.totalProductCount = 0;
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.activeAnimations = [];
      this.isRestoring = false;
      this.userHasScrolled = false;
    }

    init() {
      this.productFacet = document.querySelector('product-facet');
      if (!this.productFacet) return;

      this.productList = this.productFacet.querySelector('product-list');
      if (!this.productList) return;

      this.productListInner = this.productList.querySelector('.product-list__inner');
      if (!this.productListInner) return;

      this.currentPage = parseInt(this.productList.dataset.currentPage, 10) || 1;
      this.totalPages = parseInt(this.productList.dataset.totalPages, 10) || 1;

      // Fallback: count pagination nav items if data attributes are missing
      if (!this.productList.dataset.totalPages) {
        const paginationLinks = this.productFacet.querySelectorAll('page-pagination a[data-page]');
        if (paginationLinks.length > 0) {
          this.totalPages = Math.max(...Array.from(paginationLinks).map(a => parseInt(a.dataset.page, 10)));
        }
      }

      this.totalProductCount = this.productListInner.querySelectorAll('product-item').length;

      if (this.totalPages <= 1) return;

      this.productFacet.classList.add('infinite-scroll-active');

      this.createLoadMoreButton();
      this.setupIntersectionObserver();
      this.setupMutationObserver();
      this.setupProductClickTracking();
      this.restoreScrollPosition();
    }

    createLoadMoreButton() {
      this.loadMoreContainer = document.createElement('div');
      this.loadMoreContainer.className = 'load-more-container';

      this.loadMoreButton = document.createElement('button');
      this.loadMoreButton.type = 'button';
      this.loadMoreButton.className = 'load-more-button';
      this.loadMoreButton.innerHTML = '<span class="load-more-spinner" aria-hidden="true"></span><span class="load-more-text">Load More</span>';
      this.loadMoreButton.addEventListener('click', () => this.onButtonClick());

      this.loadMoreContainer.appendChild(this.loadMoreButton);

      this.srStatus = document.createElement('div');
      this.srStatus.className = 'infinite-scroll-sr-status';
      this.srStatus.setAttribute('role', 'status');
      this.srStatus.setAttribute('aria-live', 'polite');
      this.srStatus.setAttribute('aria-atomic', 'true');

      // Insert after product-list, inside #facet-main so it survives correctly
      this.productList.after(this.loadMoreContainer);
      this.loadMoreContainer.after(this.srStatus);
    }

    setupIntersectionObserver() {
      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
      }

      this.intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.isLoading && this.autoLoadCount < AUTO_LOAD_CAP) {
            this.loadNextPage();
          }
        });
      }, { rootMargin: '200px 0px' }); // Start loading slightly before button is visible

      this.intersectionObserver.observe(this.loadMoreButton);
    }

    setupMutationObserver() {
      const facetMain = this.productFacet.querySelector('#facet-main');
      if (!facetMain) return;

      this.mutationObserver = new MutationObserver((mutations) => {
        // Check if the product-list was replaced (filter/sort re-render)
        const productListStillExists = facetMain.querySelector('product-list');
        if (!productListStillExists || productListStillExists !== this.productList) {
          this.handleReset();
        }
      });

      this.mutationObserver.observe(facetMain, { childList: true });
    }

    async loadNextPage() {
      if (this.isLoading) return;
      if (this.currentPage >= this.totalPages) return;
      if (this.totalLoadedPages >= MAX_PAGES_TOTAL) {
        this.showViewAllLink();
        return;
      }

      this.isLoading = true;
      this.loadMoreButton.setAttribute('aria-busy', 'true');
      this.loadMoreButton.disabled = true;

      if (this.abortController) {
        this.abortController.abort();
      }
      this.abortController = new AbortController();

      if (!this.isRestoring) {
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start'));
      }

      const nextPage = this.currentPage + 1;
      const url = new URL(window.location);
      url.searchParams.set('page', nextPage);
      url.searchParams.set('section_id', this.productFacet.getAttribute('section-id'));

      try {
        const response = await fetch(url.toString(), { signal: this.abortController.signal });
        const html = await response.text();
        const newItems = this.appendProducts(html);

        this.currentPage = nextPage;
        this.autoLoadCount++;
        this.totalLoadedPages++;
        this.totalProductCount += newItems.length;

        this.updateURL(nextPage);

        if (this.isRestoring) {
          // During restore, make products visible immediately — no animation or focus shift
          newItems.forEach(item => { item.style.opacity = '1'; });
        } else {
          this.animateNewProducts(newItems);

          // Focus first new product for keyboard users
          if (newItems.length > 0) {
            const firstLink = newItems[0].querySelector('a');
            if (firstLink) {
              firstLink.focus({ preventScroll: true });
            }
          }
        }

        this.updateSRStatus();
        this.productList.dataset.currentPage = nextPage;
        if (!this.isRestoring) this.saveScrollPosition();

        if (this.currentPage >= this.totalPages) {
          this.removeLoadMore();
        } else if (this.totalLoadedPages >= MAX_PAGES_TOTAL) {
          this.showViewAllLink();
        } else if (this.autoLoadCount >= AUTO_LOAD_CAP) {
          // Pause auto-loading, keep button visible for manual clicks
          if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
          }
        }

      } catch (e) {
        if (e.name === 'AbortError') return;
        console.error('Infinite scroll: failed to load page', e);
      } finally {
        this.isLoading = false;
        this.abortController = null;
        this.loadMoreButton.setAttribute('aria-busy', 'false');
        this.loadMoreButton.disabled = false;
        if (!this.isRestoring) {
          document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end'));
        }
      }
    }

    appendProducts(html) {
      const fakeDiv = document.createElement('div');
      fakeDiv.innerHTML = html;

      const newProductListInner = fakeDiv.querySelector('.product-list__inner');
      if (!newProductListInner) return [];

      const newItems = Array.from(newProductListInner.querySelectorAll('product-item'));

      // Also update totalPages from the newly fetched content, in case it changed
      const newProductList = fakeDiv.querySelector('product-list');
      if (newProductList && newProductList.dataset.totalPages) {
        this.totalPages = parseInt(newProductList.dataset.totalPages, 10);
      }

      newItems.forEach(item => {
        item.style.opacity = '0'; // Start hidden for animation
        this.productListInner.appendChild(item);
      });

      return newItems;
    }

    animateNewProducts(items) {
      if (items.length === 0) return;

      items.forEach((item, i) => {
        const translateY = this.prefersReducedMotion ? 0 : (window.innerWidth < 1000 ? 35 : 60);
        const delay = this.prefersReducedMotion ? 0 : 100 * i - Math.min(3 * i * i, 100 * i);

        item.style.willChange = 'transform, opacity';

        const animation = item.animate(
          [
            { opacity: 0, transform: `translateY(${translateY}px)` },
            { opacity: 1, transform: 'translateY(0)' }
          ],
          {
            duration: 600,
            delay: Math.max(0, delay),
            easing: 'ease',
            fill: 'none'
          }
        );

        this.activeAnimations.push(animation);

        animation.finished.then(() => {
          item.style.opacity = '1';
          item.style.transform = '';
          item.style.willChange = '';
        }).catch(() => {
          // Animation was cancelled externally — ensure item is visible
          item.style.opacity = '1';
          item.style.transform = '';
          item.style.willChange = '';
        }).finally(() => {
          animation.cancel();
          const idx = this.activeAnimations.indexOf(animation);
          if (idx > -1) this.activeAnimations.splice(idx, 1);
        });
      });
    }

    waitForProducts() {
      return new Promise((resolve) => {
        // Wait for all product images to finish loading so layout is stable.
        const images = this.productListInner.querySelectorAll('product-item img');
        const pending = Array.from(images).filter(img => !img.complete);
        if (pending.length === 0) {
          requestAnimationFrame(resolve);
          return;
        }
        let remaining = pending.length;
        const onDone = () => {
          remaining--;
          if (remaining <= 0) requestAnimationFrame(resolve);
        };
        pending.forEach(img => {
          img.addEventListener('load', onDone, { once: true });
          img.addEventListener('error', onDone, { once: true });
        });
        // Safety timeout — don't wait forever if images are slow
        setTimeout(resolve, 5000);
      });
    }

    updateURL(page) {
      // Keep the page param out of the URL so that back-navigation always
      // server-renders page 1. The JS restore loop handles reloading pages 2-N.
      const url = new URL(window.location);
      url.searchParams.delete('page');
      history.replaceState({}, '', url.toString());
    }

    updateSRStatus() {
      if (this.srStatus) {
        // Get total from the collection count element if available
        const metaBar = this.productFacet.querySelector('.product-facet__meta-bar');
        let totalText = '';
        if (metaBar) {
          const countEl = metaBar.querySelector('.product-facet__meta-bar-item');
          if (countEl) {
            totalText = countEl.textContent.trim();
          }
        }
        this.srStatus.textContent = `Showing ${this.totalProductCount} of ${totalText || 'all'} products`;
      }
    }

    onButtonClick() {
      if (this.isLoading) return;

      // If auto-loading was paused, load one page and re-enable observer
      this.loadNextPage().then(() => {
        if (this.autoLoadCount >= AUTO_LOAD_CAP && this.currentPage < this.totalPages && this.totalLoadedPages < MAX_PAGES_TOTAL) {
          // Reset auto-load counter and re-enable observer for another batch
          this.autoLoadCount = 0;
          this.setupIntersectionObserver();
        }
      });
    }

    removeLoadMore() {
      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
        this.intersectionObserver = null;
      }
      if (this.loadMoreContainer) {
        this.loadMoreContainer.remove();
        this.loadMoreContainer = null;
        this.loadMoreButton = null;
      }
    }

    showViewAllLink() {
      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
        this.intersectionObserver = null;
      }
      if (this.loadMoreContainer) {
        const viewAllUrl = new URL(window.location);
        viewAllUrl.searchParams.delete('page');
        viewAllUrl.searchParams.set('page', this.currentPage + 1);

        this.loadMoreContainer.innerHTML = `<a href="${viewAllUrl.toString()}" class="load-more-view-all">View all products</a>`;
        this.loadMoreButton = null;
      }
    }

    handleReset() {
      this.destroy(false); // false = don't remove mutation observer yet

      this.productList = this.productFacet.querySelector('product-list');
      if (!this.productList) return;

      this.productListInner = this.productList.querySelector('.product-list__inner');
      if (!this.productListInner) return;

      this.currentPage = parseInt(this.productList.dataset.currentPage, 10) || 1;
      this.totalPages = parseInt(this.productList.dataset.totalPages, 10) || 1;
      this.autoLoadCount = 0;
      this.totalLoadedPages = 1;
      this.totalProductCount = this.productListInner.querySelectorAll('product-item').length;
      this.isLoading = false;
      this.loadMoreContainer = null;
      this.loadMoreButton = null;

      // Fallback: count pagination nav items if data attributes are missing
      if (!this.productList.dataset.totalPages) {
        const paginationLinks = this.productFacet.querySelectorAll('page-pagination a[data-page]');
        if (paginationLinks.length > 0) {
          this.totalPages = Math.max(...Array.from(paginationLinks).map(a => parseInt(a.dataset.page, 10)));
        }
      }

      if (this.totalPages <= 1) {
        this.productFacet.classList.remove('infinite-scroll-active');
        return;
      }

      this.productFacet.classList.add('infinite-scroll-active');
      this.createLoadMoreButton();
      this.setupIntersectionObserver();

      // Re-setup mutation observer on the (possibly new) #facet-main
      if (this.mutationObserver) {
        this.mutationObserver.disconnect();
      }
      this.setupMutationObserver();
    }

    saveScrollPosition() {
      try {
        const key = SESSION_KEY_PREFIX + this.getSessionKey();
        sessionStorage.setItem(key, JSON.stringify({
          maxPage: this.currentPage,
          clickedProductUrl: this.lastClickedProductUrl || null
        }));
      } catch (e) {
        // sessionStorage may be unavailable
      }
    }

    setupProductClickTracking() {
      this.productListInner.addEventListener('click', (e) => {
        const link = e.target.closest('a[href]');
        if (!link) return;
        const productItem = link.closest('product-item');
        if (!productItem) return;
        // Save the product URL path so we can find it after restore
        this.lastClickedProductUrl = link.getAttribute('href');
        this.saveScrollPosition();
      });
    }

    async restoreScrollPosition() {
      try {
        const key = SESSION_KEY_PREFIX + this.getSessionKey();
        const saved = sessionStorage.getItem(key);

        // Direct navigation to ?page=N without session storage (shared link, bookmark, etc.)
        // Redirect to page 1 so the user sees the full collection from the start.
        if (!saved && this.currentPage > 1) {
          const url = new URL(window.location);
          url.searchParams.delete('page');
          window.location.replace(url.toString());
          return;
        }

        if (!saved) return;

        const { maxPage, clickedProductUrl } = JSON.parse(saved);
        if (!maxPage || maxPage <= 1 || maxPage > MAX_PAGES_TOTAL) return;

        // If the server rendered a page other than 1 (e.g. back-button with stale ?page=N),
        // redirect to page 1 first so we can rebuild the full product list.
        if (this.currentPage > 1) {
          const url = new URL(window.location);
          url.searchParams.delete('page');
          window.location.replace(url.toString());
          return;
        }

        // Detect if the user starts scrolling during restore — if so, skip scroll restore.
        this.userHasScrolled = false;
        const onUserScroll = () => { this.userHasScrolled = true; };
        window.addEventListener('scroll', onUserScroll, { passive: true });

        // Sequentially load pages up to the saved position
        this.isRestoring = true;
        for (let page = 2; page <= maxPage; page++) {
          if (this.currentPage >= this.totalPages) break;
          await this.loadNextPage();
        }
        this.isRestoring = false;

        window.removeEventListener('scroll', onUserScroll);

        // Scroll to the clicked product — but only if the browser hasn't already restored
        // the scroll position close to it (e.g. via native back-navigation scroll restoration).
        if (clickedProductUrl && !this.userHasScrolled) {
          await this.waitForProducts();
          const target = this.productListInner.querySelector(`a[href="${CSS.escape(clickedProductUrl)}"]`);
          if (target) {
            const productItem = target.closest('product-item');
            if (productItem) {
              const rect = productItem.getBoundingClientRect();
              const isAlreadyVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;
              if (!isAlreadyVisible) {
                productItem.scrollIntoView({ block: 'center' });
              }
            }
          }
        }

        sessionStorage.removeItem(key);
      } catch (e) {
        // Ignore restoration errors
      }
    }

    getSessionKey() {
      const url = new URL(window.location);
      url.searchParams.delete('page');
      url.searchParams.delete('section_id');
      return url.pathname + url.search;
    }

    destroy(removeMutationObserver = true) {
      if (this.activeAnimations.length > 0) {
        this.activeAnimations.forEach(a => a.cancel());
        this.activeAnimations = [];
      }
      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
        this.intersectionObserver = null;
      }
      if (removeMutationObserver && this.mutationObserver) {
        this.mutationObserver.disconnect();
        this.mutationObserver = null;
      }
      if (this.abortController) {
        this.abortController.abort();
        this.abortController = null;
      }
      if (this.loadMoreContainer) {
        this.loadMoreContainer.remove();
        this.loadMoreContainer = null;
        this.loadMoreButton = null;
      }
      if (this.srStatus) {
        this.srStatus.remove();
        this.srStatus = null;
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new InfiniteScrollController().init());
  } else {
    new InfiniteScrollController().init();
  }
})();

/* ============================================
   GIFT WITH PURCHASE (GWP)

   Config comes from shop.metafields.discounts.gift_with_purchase (exposed as
   window.themeVariables.gwpRules by snippets/js-variables.liquid). Each rule's gift product is
   pre-rendered, hidden, on every page by sections/gwp-quick-buy.liquid, reusing product-quick-buy.liquid
   and product-form.liquid (see their allowed_variant_ids param) so the variant picker only offers that
   rule's eligible gift variants.

   Each rule gets a plain <drawer-content data-gwp-drawer> shell (the theme's own drawer element - no
   subclass needed). On load we move its rule's markup out of its inert <template> and into that shell
   once, so opening it later needs no fetch (unlike the theme's own fetch-on-open <quick-buy-drawer>,
   since the content already exists). GwpController just watches cart:updated/cart:refresh to decide,
   per rule, whether to open its drawer (trigger threshold newly met) or remove the gift line (trigger
   condition no longer met, e.g. the customer removed/reduced the triggering item).
   ============================================ */
(function () {
  'use strict';

  document.querySelectorAll('[data-gwp-drawer]').forEach((drawer) => {
    const template = document.getElementById(drawer.dataset.templateId);
    if (!template) return;

    const source = template.content.querySelector('quick-buy-drawer');
    if (source) {
      Array.from(source.children).forEach((child) => drawer.appendChild(child));
    }
    template.remove();
  });

  // Only the drawer's "No thanks" button counts as a decline for this session. Closing with the X,
  // the overlay or escape just hides the drawer; the offer comes back on the next cart event.
  document.addEventListener('click', (event) => {
    const declineButton = event.target.closest && event.target.closest('[data-gwp-decline]');
    if (!declineButton) return;

    const drawer = declineButton.closest('[data-gwp-drawer]');
    if (!drawer) return;

    console.debug('[GWP] gift declined, marking dismissed', { ruleId: drawer.dataset.ruleId });
    GwpController.setDismissed(drawer.dataset.ruleId, true);
    drawer.open = false;
  });

  // Adding the gift closes its drawer (without dismissing) so the cart drawer can take over.
  document.addEventListener('variant:added', (event) => {
    const drawer = event.target.closest && event.target.closest('[data-gwp-drawer]');
    if (drawer) drawer.open = false;
  });

  document.addEventListener('openable-element:close', () => {
    if (miniCartReopenQueued && !document.querySelector('[data-gwp-drawer][open]')) {
      const miniCart = document.getElementById('mini-cart');
      if (miniCart) {
        console.debug('[GWP] all gwp drawers closed, opening queued mini cart');
        miniCartReopenQueued = false;
        miniCart.open = true;
      }
    }
  });

  // The theme's own cart-drawer.js opens #mini-cart on every add-to-cart (see cart:refresh's
  // openMiniCart flag in theme.js). While a GWP drawer is up, that would bury it behind the cart
  // drawer, so refuse the open here and defer it until the GWP drawer above is closed.
  //
  // This has to guard the `open` setter rather than undo the open from an openable-element:open
  // listener: the header cart toggle-link reacts to that event by setting aria-expanded="true",
  // which calls mini-cart.open = true again, so closing it from the listener just re-fires the
  // event forever.
  let miniCartReopenQueued = false;

  function guardMiniCartOpen() {
    const miniCart = document.getElementById('mini-cart');
    if (!miniCart || miniCart.hasAttribute('data-gwp-guarded')) return;

    let proto = Object.getPrototypeOf(miniCart);
    let descriptor = null;
    while (proto && !descriptor) {
      descriptor = Object.getOwnPropertyDescriptor(proto, 'open');
      proto = Object.getPrototypeOf(proto);
    }
    if (!descriptor || !descriptor.set) return;

    miniCart.setAttribute('data-gwp-guarded', '');
    Object.defineProperty(miniCart, 'open', {
      configurable: true,
      get() {
        return descriptor.get.call(this);
      },
      set(value) {
        const pendingGwpDrawer = value && document.querySelector('[data-gwp-drawer][open]');
        if (pendingGwpDrawer) {
          console.debug('[GWP] blocking mini cart auto-open while gwp drawer is up', { ruleId: pendingGwpDrawer.dataset.ruleId });
          miniCartReopenQueued = true;
          return;
        }
        descriptor.set.call(this, value);
      }
    });
  }

  // custom.js is deferred ahead of theme.js, so #mini-cart isn't upgraded (no `open` accessor) yet.
  customElements.whenDefined('cart-drawer').then(guardMiniCartOpen);

  class GwpController {
    // Rule ids with a single-variant gift add currently in flight. A single add-to-cart fires
    // both cart:updated and cart:refresh back-to-back from the same fetched cart snapshot (see
    // cart-drawer's _rerenderCart in theme.js), so both events reach _evaluate before our own
    // add's response has come back and a fresh cart snapshot can show the new gift line. Without
    // this guard, that second evaluation still sees no gift line and fires a second add.
    static _pendingSingleVariantAdds = new Set();

    static numericId(gid) {
      return String(gid).split('/').pop();
    }

    static _dismissKey(ruleId) {
      return `gwp:dismissed:${ruleId}`;
    }

    static isDismissed(ruleId) {
      try {
        return sessionStorage.getItem(GwpController._dismissKey(ruleId)) === '1';
      } catch (e) {
        return false;
      }
    }

    static setDismissed(ruleId, value) {
      try {
        if (value) {
          sessionStorage.setItem(GwpController._dismissKey(ruleId), '1');
        } else {
          sessionStorage.removeItem(GwpController._dismissKey(ruleId));
        }
      } catch (e) {
        // sessionStorage may be unavailable (e.g. Safari private mode)
      }
    }

    // Tracks whether we've previously seen a rule's gift line in the cart, so a later evaluation
    // that finds it gone (rather than just never having been added) can tell "the shopper removed
    // it" apart from "it hasn't been earned yet" and treat only the former as a decline.
    static _hadGiftKey(ruleId) {
      return `gwp:had-gift:${ruleId}`;
    }

    static hadGift(ruleId) {
      try {
        return sessionStorage.getItem(GwpController._hadGiftKey(ruleId)) === '1';
      } catch (e) {
        return false;
      }
    }

    static setHadGift(ruleId, value) {
      try {
        if (value) {
          sessionStorage.setItem(GwpController._hadGiftKey(ruleId), '1');
        } else {
          sessionStorage.removeItem(GwpController._hadGiftKey(ruleId));
        }
      } catch (e) {
        // sessionStorage may be unavailable (e.g. Safari private mode)
      }
    }

    init() {
      // cart:updated alone is enough. Every place that dispatches cart:refresh (add-to-cart,
      // line-item quantity changes - see theme.js) dispatches cart:updated first, from the exact
      // same fetched cart snapshot, so listening to both means every rule gets evaluated twice
      // per actual change, back-to-back, before the first evaluation's own add-to-cart response
      // has come back - which the _pendingSingleVariantAdds guard below exists to survive, but is
      // better not to rely on alone. Page load is still covered: js-variables.liquid's pageshow
      // handler dispatches cart:updated too (see that file) using the same fetch it already does
      // for cart:refresh, so this needs no fetch of its own.
      this._onCartEvent = this._onCartEvent.bind(this);
      document.documentElement.addEventListener('cart:updated', this._onCartEvent);
      console.debug('[GWP] controller initialized', { rules: Object.keys((window.themeVariables && window.themeVariables.gwpRules) || {}) });
    }

    _onCartEvent(event) {
      const cart = event.detail && event.detail.cart;
      console.debug('[GWP] cart event received', { type: event.type, hasCart: !!cart, itemCount: cart && cart.items ? cart.items.length : 0 });
      if (cart && cart.items) {
        this._evaluate(cart, { respectDismissed: true });
      }
    }

    _evaluate(cart, { respectDismissed }) {
      const rules = (window.themeVariables && window.themeVariables.gwpRules) || {};

      Object.keys(rules).forEach((ruleId) => {
        const rule = rules[ruleId];
        if (!rule || (rule.ruleType !== 'TRIGGER_PRODUCT' && rule.ruleType !== 'ORDER_SUBTOTAL')) return;

        const drawer = document.getElementById(`gwp-drawer-${ruleId}`);
        if (!drawer) {
          console.debug('[GWP] no drawer found for rule, skipping', { ruleId });
          return;
        }

        let giftLine = null;
        cart.items.forEach((item) => {
          if (item.properties && item.properties._gwp_trigger_rule_id === ruleId) {
            giftLine = item;
          }
        });

        if (giftLine) {
          GwpController.setHadGift(ruleId, true);
        } else if (GwpController.hadGift(ruleId)) {
          console.debug('[GWP] gift line removed from cart, marking dismissed', { ruleId });
          GwpController.setHadGift(ruleId, false);
          GwpController.setDismissed(ruleId, true);
        }

        let triggerMet, debugInfo;

        if (rule.ruleType === 'ORDER_SUBTOTAL') {
          // The subtotal is checked AFTER line-level discounts (item.final_line_price), because the
          // discount Function can't see other discounts' effect on the cart (e.g. a 20% sale
          // discount) and so can't make this call itself - the theme picks up that slack. The
          // rule's gift variants are excluded so the gift can't qualify the cart on its own (its
          // discounted price is $0 anyway). Cart API prices are in cents; minimumSubtotal is a
          // decimal-dollar string. Order-level discounts (e.g. a 10% off order code) are not in
          // final_line_price, so they're subtracted separately from
          // cart.cart_level_discount_applications (each one's total_allocated_amount).
          const giftIds = (rule.giftVariantIds || []).map(GwpController.numericId);
          const minimumSubtotalCents = Math.round(Number(rule.minimumSubtotal || 0) * 100);
          const lineSubtotalCents = cart.items.reduce(
            (sum, item) => (giftIds.includes(String(item.variant_id)) ? sum : sum + item.final_line_price),
            0
          );
          const orderDiscountCents = (cart.cart_level_discount_applications || []).reduce(
            (sum, discount) => sum + Math.round(Number(discount.total_allocated_amount || 0)),
            0
          );
          const subtotalCents = lineSubtotalCents - orderDiscountCents;
          triggerMet = subtotalCents >= minimumSubtotalCents;
          debugInfo = { subtotalInCart: subtotalCents, lineSubtotalCents, orderDiscountCents, minimumSubtotalCents };
        } else {
          const triggerIds = (rule.triggerVariantIds || []).map(GwpController.numericId);
          const triggerQuantity = rule.triggerQuantity || 1;

          // The Function can't be mirrored for collection triggers (the cart has no collection
          // membership), and a rule with no trigger variants has nothing to check. Leave both
          // alone entirely - evaluating them as "not met" would strip a gift the Function grants.
          if (rule.triggerMode === 'COLLECTION' || triggerIds.length === 0) {
            console.debug('[GWP] trigger can not be evaluated in the theme, skipping rule', { ruleId, triggerMode: rule.triggerMode });
            return;
          }

          let triggerQuantityInCart = 0;
          cart.items.forEach((item) => {
            if (triggerIds.includes(String(item.variant_id))) {
              triggerQuantityInCart += item.quantity;
            }
          });

          triggerMet = triggerQuantityInCart >= triggerQuantity;
          debugInfo = { triggerQuantityInCart, triggerQuantity };
        }

        // The rule no longer qualifies (trigger item removed, quantity lowered, or subtotal fell
        // below the minimum) but its gift line is still in the cart - take it out so the shopper
        // isn't left holding a gift they no longer earn.
        if (!triggerMet && giftLine) {
          GwpController.removeGiftLine(ruleId, giftLine);
          return;
        }

        // A decline only means "not this time" - once the trigger condition drops (they removed
        // the item, or the subtotal fell back below the threshold) and later becomes true again,
        // that's a fresh offer, not a continuation of the one they turned down.
        if (!triggerMet && GwpController.isDismissed(ruleId)) {
          console.debug('[GWP] trigger no longer met, clearing dismissed', { ruleId });
          GwpController.setDismissed(ruleId, false);
        }

        const dismissed = respectDismissed && GwpController.isDismissed(ruleId);

        console.debug('[GWP] rule evaluated', {
          ruleId,
          ruleType: rule.ruleType,
          ...debugInfo,
          triggerMet,
          hasGiftLine: !!giftLine,
          respectDismissed,
          dismissed
        });

        if (triggerMet && !giftLine && !dismissed) {
          const giftVariantIds = rule.giftVariantIds || [];

          // Decided purely off the rule's own gift variant list, never the underlying product's
          // variant count: a product can have several variants while a given rule still only
          // offers one of them as the gift, and that still shouldn't show a picker.
          if (giftVariantIds.length === 1) {
            if (GwpController._pendingSingleVariantAdds.has(ruleId)) {
              console.debug('[GWP] single-variant add already in flight for rule, skipping', { ruleId });
            } else {
              GwpController.addSingleVariantGift(ruleId, drawer, giftVariantIds[0]);
            }
          } else {
            console.debug('[GWP] opening drawer for rule', { ruleId });
            drawer.open = true;
          }
        }
      });
    }

    // Removes an unearned gift line via /cart/change.js (by line key, so it can't hit the wrong
    // line if the cart shifted) and re-broadcasts the returned cart so the mini cart, cart count
    // and this controller's own next evaluation all see it gone. The in-flight guard stops the
    // back-to-back cart events from firing a second removal before the first has returned.
    static _pendingRemovals = new Set();

    static removeGiftLine(ruleId, giftLine) {
      if (GwpController._pendingRemovals.has(ruleId)) return;
      GwpController._pendingRemovals.add(ruleId);

      console.debug('[GWP] trigger not met, removing gift line from cart', { ruleId, key: giftLine.key });

      const cartUrl = (window.themeVariables && window.themeVariables.routes && window.themeVariables.routes.cartUrl) || '/cart';

      fetch(`${cartUrl}/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: giftLine.key, quantity: 0 })
      })
        .then((response) => {
          if (!response.ok) throw new Error(`cart/change.js returned ${response.status}`);
          return response.json();
        })
        .then((cart) => {
          // The shopper didn't decline anything, so don't leave a dismissal behind either.
          GwpController.setHadGift(ruleId, false);
          GwpController.setDismissed(ruleId, false);
          document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));
        })
        .catch((error) => {
          console.debug('[GWP] failed to remove gift line', { ruleId, error });
        })
        .finally(() => {
          GwpController._pendingRemovals.delete(ruleId);
        });
    }

    // Reuses the rule's own pre-rendered, pre-filled product-form (the same web component the
    // drawer's own "Add to cart" button submits) instead of duplicating the add-to-cart request
    // here. The form is live DOM even while its drawer is closed - assets/custom.js moves each
    // rule's markup out of its inert <template> on load, see the top of this GWP block - so this
    // only has to force the correct variant id onto it (since a rule can restrict a multi-variant
    // product down to a single eligible gift variant, and that product's own default/first-available
    // variant won't necessarily be the right one) and submit.
    static addSingleVariantGift(ruleId, drawer, giftVariantGid) {
      const form = drawer.querySelector(`#gwp-product-form-${ruleId}`);
      if (!form) {
        console.debug('[GWP] single-variant gift form not found, falling back to drawer', { ruleId });
        drawer.open = true;
        return;
      }

      console.debug('[GWP] single-variant gift, adding to cart directly', { ruleId, giftVariantGid });
      GwpController._pendingSingleVariantAdds.add(ruleId);

      // cart-notification:show fires once per submit, right after the /cart/add.js response
      // resolves (success or failure) - see ProductForm._onSubmit in theme.js - which is before
      // this add's own cart:updated/cart:refresh dispatch, but after the line already exists (or
      // failed to) server-side, so any other cart event from this point on reflects it correctly.
      form.addEventListener('cart-notification:show', () => {
        GwpController._pendingSingleVariantAdds.delete(ruleId);
      }, { once: true });

      form.id.value = GwpController.numericId(giftVariantGid);
      form.requestSubmit();
    }
  }

  new GwpController().init();
})();
